var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    fill: "#0C0D14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.3135 19.6686C44.2288 20.56 44.2288 22.0052 43.3135 22.8967L26.4385 39.3314C25.5232 40.2229 24.0393 40.2229 23.124 39.3314L14.6865 31.114C13.7712 30.2226 13.7712 28.7774 14.6865 27.886C15.6018 26.9945 17.0857 26.9945 18.001 27.886L24.7812 34.4893L39.999 19.6686C40.9143 18.7771 42.3982 18.7771 43.3135 19.6686Z",
    fill: "#3DEFB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.e7ade6157a36b25edd95d6b3f01de0d3.svg";
export { ForwardRef as ReactComponent };